export default __webpack_public_path__ + "static/media/Footer_mail.66da08a8.svg";